<template>
  <div class="transaction_list">
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>

          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <v-card outlined elevation="0" class="py-3 rounded-lg">
            <div class="d-flex align-center">
              <div>
                <div class="text-start px-5">
                  <div class="pt-1 text-body-1 font-weight-bold mb-4">LIBRARY</div>
                  <div class="pt-1 text-body-2">
                    Di fitur library Banni Book, Anda dapat menemukan semua buku yang telah Anda
                    beli dengan mudah. Dengan koleksi buku yang terus diperbarui, Anda tidak akan
                    pernah kehabisan bacaan menarik. Temukan kembali karya-karya favorit Anda dengan
                    mudah menggunakan fitur library kami yang dapat Anda akses di aplikasi Banni
                    Book versi mobile.
                    <br /><br />
                    Klik “Install Sekarang” atau "Baca Sekarang" untuk menikmati kemudahan akses membaca buku dimanapun
                    dan kapanpun!
                  </div>
                  <div>
                    <div class="pt-4">
                      <a href="https://play.google.com/store/apps/details?id=banni.book" class="text-deco">
                        <v-btn
                          large
                          class="install text-capitalize font-weight-bold rounded-lg"
                          >
                          <v-img src="/assets/icons/before.png"></v-img>
                          Install Sekarang
                          </v-btn
                        >
                      </a>
                    </div>
                    <div class="pt-4">
                      <a href="https://m.bannibook.com" class="text-deco">
                        <v-btn
                          large
                          class="install text-capitalize font-weight-bold rounded-lg"
                          >
                          <i aria-hidden="true" class="v-icon notranslate mdi mdi-book-multiple theme--light"></i>
                          Baca Sekarang
                          </v-btn
                        >
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mr-5 hide-mobile">
                <v-row class="d-flex justify-center">
                  <v-img width="100%" src="/assets/icons/library.png"></v-img>
                </v-row>
              </div>
            </div>
          </v-card>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";

export default {
  components: {
    ProfileMenu
  },
  data() {
    return {
      loadingProfile: false,
      domain: process.env.VUE_APP_DOMAIN,
      page: 1,
      limit: 5,
      params: [],
      sortBy: "user_id",
      sortDir: "DESC",
      invoice_selected: ""
    };
  },
  computed: {
    ...mapState("profile", ["detailProfile", "response"])
  },
  methods: {
    ...mapActions("profile", ["getProfileDetail"])
  },
  created() {
    this.getProfileDetail();
    this.$store.dispatch("setPageTitle", "Library");
  }
};
</script>

<style lang="scss" scoped>
.install {
  color: #1951EF;
  background-color: transparent;
  border: #1951EF 1px solid;
}

.hide-mobile {
  display: block;
}

@media (max-width: 600px) {
  .hide-mobile {
    display: none;
  }
}
</style>